import Vue from 'vue'
import supplyConfigTransformer from '../../../transformers/catalog/warehouse/supplyConfig'

/**
 * @author jorge nuñez lópez <>
 *
 * Create a new supply configuration
 * @param newConfig New supply config object
 * @return {object}
 */

export default (newConfig, warehouseId) => {
  const payload = supplyConfigTransformer.send(newConfig)
  return Vue.$http.post(`iwarehouse/supply-list-create/${warehouseId}/`, payload)
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/createSupplyConfig.js